import gql from "graphql-tag";
import {
  FRAGMENT_MEDIA_ITEM,
  FRAGMENT_NEIGHBORHOOD_DETAILS,
} from "./fragments.js";

export const GET_QMI = gql`
  ${FRAGMENT_MEDIA_ITEM}
  ${FRAGMENT_NEIGHBORHOOD_DETAILS}
  query GetQMI($uri: ID!) {
    home(id: $uri, idType: URI) {
      databaseId
      id
      title
      collection {
        collection
        fieldGroupName
      }
      productStatus {
        enableSnipeLink
        fieldGroupName
        sectionId
        statusCustom
        statusMessage
      }
      qmiHomeDetails {
        address1
        address2
        city
        bathrooms
        bedrooms
        finishedSqrFt
        garage
        latitude
        longitude
        matterportTour
        matterportTourTitle
        pdfEPub
        price
        virtualTour
        elevations {
          ...MediaItemFragment
        }
        neighborhood {
          ... on Neighborhood {
            id
            slug
            title
            uri
          }
        }
        floorplan {
          ... on Plan {
            databaseId
            id
            title
            uri
            floorplanDetails {
              planNotAvailable
              collection
              displayTitle
              homeType
              type
              neighborhood {
                ...NeighborhoodDetailsFragment
              }
            }
          }
        }
        galleryItems {
          type
          videoUrl
          thumbnail {
            ...MediaItemFragment
          }
          image {
            ...MediaItemFragment
          }
        }
        tabs {
          title
          image {
            ...MediaItemFragment
          }
        }
      }
    }
    collectionFeatures
  }
`;
